import React from "react";

const LedgerOpeningBalance = () => {

  return <div>LedgerOpeningBalance</div>;
};

export default LedgerOpeningBalance;
